// frontend/src/api/group.api.js
import apiClient from './client.js';

export const getGroups = async () => {
  const response = await apiClient.get('/groups');
  return response.data.data;
};

export const getGroup = async (id) => {
  const response = await apiClient.get(`/groups/${id}`);
  return response.data.data;
};

export const createGroup = async (data) => {
  const response = await apiClient.post('/groups', data);
  return response.data.data;
};

export const updateGroup = async (id, data) => {
  const response = await apiClient.put(`/groups/${id}`, data);
  return response.data.data;
};

export const deleteGroup = async (id) => {
  const response = await apiClient.delete(`/groups/${id}`);
  return response.data.data;
};

export const assignEntitiesToGroup = async (id, entityIds) => {
  const response = await apiClient.put(`/groups/${id}/assign-entities`, { entityIds });
  return response.data.data;
};
